import { Injectable } from "@angular/core";

import { BroadcasterService as BaseBroadcasterService } from "@bitwarden/common/platform/services/broadcaster.service";

@Injectable()
export class BroadcasterService extends BaseBroadcasterService {}
